<script setup>

import { ref } from "vue";
import UtilArray from "@/utils/UtilArray.mjs";
import CartaoListaDeDados from "./ListaDeDados/CartaoListaDeDados.vue";
import VisualizarDadosModal from "./VisualizarDados/VisualizarDadosModal.vue";
import LiberarDadosModal from "./LiberarDados/LiberarDadosModal.vue";
import AprovarDadosModal from "./AprovarDados/AprovarDadosModal.vue";
import GerarPagamentosModal from "./GerarPagamentos/GerarPagamentosModal.vue";
import BaixarDadosModal from "./BaixarDados/BaixarDadosModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//======================== Dados Originais =========================//
//==================================================================//

const dadosOriginais = ref([]);
const dadoOriginal = ref({});

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//====================== Visualizando Dado =========================//
//==================================================================//

const visualizandoDado = ref(false);

//==================================================================//
//======================= Liberando Dado ===========================//
//==================================================================//

const liberandoDado = ref(false);

//==================================================================//
//======================= Aprovando Dado ===========================//
//==================================================================//

const aprovandoDado = ref(false);

//==================================================================//
//===================== Gerando Pagamentos =========================//
//==================================================================//

const gerandoPagamentos = ref(false);

//==================================================================//
//======================== Baixando Dado ===========================//
//==================================================================//

const baixandoDado = ref(false);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//==================== Altera Dados Originais ======================//
//==================================================================//

const alteraDadosOriginais = (update=[])=>{

    dadosOriginais.value = update;

};

//==================================================================//
//================== Altera Dado Original ==========================//
//==================================================================//

const alteraDadoOriginal = (update={})=>{

    dadoOriginal.value = update

};

//==================================================================//
//=================== Altera Visualizando Dado =====================//
//==================================================================//

const alteraVisualizandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    visualizandoDado.value = update?.modal || false;

};

//==================================================================//
//==================== Altera Liberando Dado =======================//
//==================================================================//

const alteraLiberandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    liberandoDado.value = update?.modal || false;
   
};

//==================================================================//
//==================== Altera Aprovando Dado =======================//
//==================================================================//

const alteraAprovandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    aprovandoDado.value = update?.modal || false;
   
};

//==================================================================//
//================ Altera Gerando Pagamentos =======================//
//==================================================================//

const alteraGerandoPagamentos = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    gerandoPagamentos.value = update?.modal || false;
   
};

//==================================================================//
//===================== Altera Baixando Dado =======================//
//==================================================================//

const alteraBaixandoDado = (update={})=>{

    alteraDadoOriginal(update?.dadoOriginal || {});
    baixandoDado.value = update?.modal || false;

};

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>Contas a Pagar</h2>

        <CartaoListaDeDados
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :visualizandoDado="visualizandoDado"
            :liberandoDado="liberandoDado"
            :aprovandoDado="aprovandoDado"
            :gerandoPagamentos="gerandoPagamentos"
            :baixandoDado="baixandoDado" 
            :dadosOriginais="dadosOriginais"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
            @update:alteraLiberandoDado="alteraLiberandoDado"
            @update:alteraGerandoPagamentos="alteraGerandoPagamentos"
            @update:alteraAprovandoDado="alteraAprovandoDado"
            @update:alteraBaixandoDado="alteraBaixandoDado"
            @update:alteraDadosOriginais="alteraDadosOriginais"
        ></CartaoListaDeDados>
        
        <VisualizarDadosModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :visualizandoDado="visualizandoDado"
            :dadoOriginal="dadoOriginal"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
        ></VisualizarDadosModal>

        <LiberarDadosModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :liberandoDado="liberandoDado"
            :dadoOriginal="dadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraLiberandoDado="alteraLiberandoDado"
        ></LiberarDadosModal>

        <AprovarDadosModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :aprovandoDado="aprovandoDado"
            :dadoOriginal="dadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraAprovandoDado="alteraAprovandoDado"
        ></AprovarDadosModal>

        <GerarPagamentosModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :gerandoPagamentos="gerandoPagamentos"
            :dadoOriginal="dadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraGerandoPagamentos="alteraGerandoPagamentos"
        ></GerarPagamentosModal>

        <BaixarDadosModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :baixandoDado="baixandoDado"
            :dadoOriginal="dadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraBaixandoDado="alteraBaixandoDado"
        ></BaixarDadosModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>